import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BindQueryParamsDirective } from './bind-query-params.directive';
import { VarDirective } from './ng-var.directive';
import {ClearButtonComponent, ClearableDirective} from './clearable.directive';
import { CurrencyFormatDirective } from './currency-format.directive';
import { ItNumberFormatDirective } from './it-number-format.directive';


@NgModule({
  declarations: [VarDirective, BindQueryParamsDirective, ClearableDirective, ClearButtonComponent, CurrencyFormatDirective, ItNumberFormatDirective],
  imports: [
    CommonModule
  ],
  exports: [VarDirective, BindQueryParamsDirective, ClearableDirective, ClearButtonComponent, CurrencyFormatDirective, ItNumberFormatDirective],
})
export class CustomDirectivesModule { }
